import { bl_wrty_product_registration_attachment_RowClass, bl_wrty_product_registration_attachment_RowInterface } from "../../../dbschema";
import { BaseContainerModel } from "../../base-container.model";

export class WarrantyProductRegistrationAttachmentContainerModel extends BaseContainerModel {
  bl_wrty_product_registration_attachment: bl_wrty_product_registration_attachment_RowInterface
    = new bl_wrty_product_registration_attachment_RowClass();
}